import { ILang } from "@dietdoctor/elements";

export function langFromHtml(doc: Document): string | undefined {
  const html = doc.querySelector("html");
  return html.dataset.language;
}

export function langFromLocation(doc: Document): string | null {
  const maybeArray: RegExpExecArray | null = /^[/]?(es|en|se|sv|us)[/]?/.exec(
    doc.location.pathname
  );
  return Array.isArray(maybeArray) ? maybeArray[1] : null;
}

export function normalizeLang(lang: string): ILang {
  if (lang === "se") return ILang.sv;
  if (lang === "us") return ILang.en;
  return lang as ILang;
}

export const getLang = (doc: Document) =>
  normalizeLang(langFromHtml(doc) ?? langFromLocation(doc) ?? ILang.en);
